import * as React from "react";

import { gql, graphql, ChildProps } from "react-apollo";
import handleMutationError from "app/utils/handleMutationError";
import { Button, Typography, TextField } from "@material-ui/core";
import withDialog, { DialogProp } from "app/utils/withDialog";

type State = {
  loading: boolean;
};

type MutationResult = {
  create_user_account_deletion_request: {
    requester_id: string;
    requester_type: string;
    error: string;
    error_message: string;
  };
};

type Props = ChildProps<
  {
    external_reference: string;
    has_valid_deletion_request: boolean;
    latest_valid_deletion_request_status: string;
    refetch: any;
  } & DialogProp &
    RouteComponentProps,
  MutationResult
>;

class AccountDeletionRequestControl extends React.Component<Props, State> {
  comment = "";

  onCommentsChange(nextApprovalComments: string) {
    this.comment = nextApprovalComments;
  }

  constructor(props) {
    super(props);
    this.state = {
      loading: false,
    };
  }

  createDeletionRequest() {
    this.setState({ loading: true });
    this.props
      .mutate({
        variables: {
          external_reference: this.props.external_reference,
          comment: this.comment,
        },
      })
      .then((response) => {
        this.setState({ loading: false });
        if (response.data.create_user_account_deletion_request.error) {
          throw new Error(
            response.data.create_user_account_deletion_request.error_message
          );
        }
        this.props.refetch();
      })
      .catch((error) => {
        this.setState({ loading: false });
        handleMutationError(error);
      });
  }

  confirmDeletionRequest() {
    this.props.dialog.prompt({
      content: (
        <div>
          <Typography
            variant="h6"
            component="h5"
            style={{ marginBottom: "20px" }}
          >
            Please confirm creating a deletion <br />
            request for this account.
          </Typography>
          <div>
            <label style={{ color: "black", display: "block" }}>
              Comments (Ticket #):{" "}
            </label>

            <TextField
              multiline
              type="text"
              onChange={(event) => this.onCommentsChange(event.target.value)}
              style={{
                display: "block",
                width: "320px",
                marginTop: "8px",
              }}
            />
          </div>
        </div>
      ),
      buttons: [
        {
          label: "Confirm",
          action: this.createDeletionRequest.bind(this),
        },
        {
          label: "Cancel",
        },
      ],
    });
  }

  render() {
    if (!this.props.has_valid_deletion_request) {
      return (
        <Button
          disabled={this.state.loading}
          onClick={() => this.confirmDeletionRequest()}
          style={{
            textTransform: "none",
            color: "#6b7280",
            border: "1px solid #d1d5db",
            borderRadius: "4px",
            minWidth: "140px",
          }}
        >
          {this.state.loading ? "Submitting..." : "Request Deletion"}
        </Button>
      );
    }
    return <label>{this.props.latest_valid_deletion_request_status}</label>;
  }
}

const withCreateUserAccountDeletionRequestMutation = graphql<
  MutationResult,
  Props
>(
  gql`
    mutation createUserAccountDeletionRequest(
      $external_reference: String!
      $comment: String!
    ) {
      create_user_account_deletion_request(
        external_reference: $external_reference
        comment: $comment
      ) {
        requester_id
        requester_type
        error
        error_message
      }
    }
  `
);

export default withDialog(
  withCreateUserAccountDeletionRequestMutation(AccountDeletionRequestControl)
);
